import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "@/components/UI/Link/Link";
import "react-image-crop/dist/ReactCrop.css";
import Button from "@/components/UI/Button/Button";
import classNames from "classnames";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section05Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const FeaturesSection = ({ className, job, page, section, ...props }: Section05Props) => {
  return (
    <Section className={classNames("bg-vpBlue-900", className)} section={section} {...props}>
      <SectionContainer section={section}>
        <div
          className={classNames("flex flex-1 gap-10", {
            "flex-row-reverse": section?.Orientation === "End",
          })}
        >
          {section?.Image?.data?.attributes && (
            <div className="hidden lg:block lg:flex-1">
              <Image
                alt={section?.Image?.data?.attributes?.alternativeText}
                src={section?.Image?.data?.attributes?.url}
                width={section?.Image?.data?.attributes?.width ?? "100"}
                height={section?.Image?.data?.attributes?.height ?? "100"}
                priority
              />
            </div>
          )}
          <div className="flex flex-1 flex-col gap-10">
            <SectionHeader
              className={classNames("text-left", {
                "justify-end": section?.Orientation === "End",
              })}
              section={section}
              slots={{
                subtitle: {
                  css: "text-white",
                },
                title: {
                  css: "text-white",
                },
              }}
            />
            {section?.List?.length > 0 && (
              <ul className="flex flex-col gap-2">
                {section?.List?.map((item: any) => {
                  return (
                    <li className="flex items-center gap-2 text-white" key={item?.id}>
                      <FontAwesomeIcon icon={faCheck} />
                      <span>{item?.Value}</span>
                    </li>
                  );
                })}
              </ul>
            )}
            {section?.Button && (
              <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
                <Button size="large">{section?.Button?.Value}</Button>
              </Link>
            )}
          </div>
        </div>
        {section?.Features?.length && (
          <div className="flex flex-col gap-16">
            <hr className="m-0 mx-auto flex h-px w-3/4 shrink-0 divide-y border-0 bg-vpBlue-800" />
            <div className="flex flex-col gap-10 lg:flex-row">
              {section?.Features?.map((feature: any) => {
                return (
                  <div className="flex flex-col gap-4" key={feature?.id}>
                    <div className="text-lg font-bold text-white">{feature?.Title}</div>
                    <div className="text-white">{feature?.Subtitle}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </SectionContainer>
    </Section>
  );
};

export default FeaturesSection;
